import PropTypes from 'prop-types'
import { cn } from 'lib/utils'

export const AdasCircularProgress = ({ size = 40, color = 'primary', className, sx, ...props }) => (
  <svg
    className={cn('animate-spin', color === 'primary' ? 'text-primary' : 'text-secondary', className)}
    style={{ width: size, height: size }}
    viewBox='0 0 24 24'
    fill='none'
    {...props}
  >
    <circle className='opacity-25' cx='12' cy='12' r='10' stroke='currentColor' strokeWidth='4' />
    <path className='opacity-75' fill='currentColor' d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z' />
  </svg>
)

AdasCircularProgress.propTypes = { size: PropTypes.number, color: PropTypes.string, className: PropTypes.string }
